import { render, staticRenderFns } from "./NewChatMessenger.vue?vue&type=template&id=47321505"
import script from "./NewChatMessenger.vue?vue&type=script&lang=js"
export * from "./NewChatMessenger.vue?vue&type=script&lang=js"
import style0 from "./NewChatMessenger.vue?vue&type=style&index=0&id=47321505&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports